import ReactGA from 'react-ga';

let GAKey = ''
let debug = false;
// Check the location
if( window.location.hostname === 'dev.etelconnections.com' ) {
  GAKey='UA-161183792-1'
} else if( window.location.hostname === 'etelconnections.com' ) {
  GAKey='UA-161199641-1';
} else if( window.location.hostname === '172.16.0.112' ) {
  GAKey = 'UA-161183221-1'
  debug = true;
}

ReactGA.initialize( GAKey, {
  debug: debug
} );

const initialState = {
  ReactGA  
};

export default function reducer( state = initialState, action ) {
  switch( action.type ) {
  case 'GOOGLE_ANALYTICS_PAGEVIEW': {
      let ReactGA = state.ReactGA;
      ReactGA.pageview(action.payload.url);
      let newState = { ...state, ReactGA };
      return newState;
    } case 'GOOGLE_ANALYTICS_MODALVIEW': {
      let ReactGA = state.ReactGA;
      ReactGA.modalview(action.payload.url);
      let newState = { ...state, ReactGA };
      return newState;
    }
    case 'GOOGLE_ANALYTICS_EVENT': {
      let ReactGA = state.ReactGA;
      ReactGA.event({
        category: action.payload.category,
        action: action.payload.action,
        label: action.payload.label
      });
      let newState = { ...state, ReactGA };
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/google.js